<div class="content">

    <div class="text-left mt-5">

        <h3>How to do LIVE broadcast ?</h3> <br>

        <ul class="list-group ps-5">

            <li>
                <p><b>Create Sessions: </b>Please check this link to see how to <a routerLink="/apilist/create-session"
                        target="_blank">create session.</a> API will return session id.</p>
                <p>
                    Note that invoking the <a routerLink="/apilist/get-region"
                    target="_blank">'getRegion'</a> function will yield deployment details, required for utilization
                    in creation session API.
                </p>
            </li>

            <li>
                <p>
                    <b>Get session details: </b>Using session id , call the API to <a routerLink="/apilist/get-session"
                        target="_blank">get details.</a> Please wait for few minutes after session is created. Keep
                    checking the API response, till session is READY. Please note Input endpoint and output end point
                    (or manifest path) from Get session API response.
                </p>
            </li>

            <li>
                <p>
                    <b>Broadcast to Endpoint: </b>One the session is READY, we can broadcast to input endpoint and live
                    will be available at output endpoint.
                </p>
            </li>

        </ul>

        <p>Here we are broadcasting a video pride.mp4 using ffmpeg. We are broadcasting to input RTMP endpoint which we
            got from get session API call response.</p>

        <p>We can use any other software to do live stream, examples OBS Studio.</p>

        <p>Using Akamai HLS Player, we can view the output. From getSession response, we got the output endpoint or
            manifest path : https://media.optimusdrive.ai/live/ef0556cf-d62d-4ee6-90fb-3437cd972e89/hls/master.m3u8</p>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm"
                        (click)="copyJsonToClipboard()">
                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>

                    <button style="float: right;" *ngIf="copiedButton" class="btn btn-success btn-sm">
                        Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>

                </div><br><br>

                <pre><code [innerHTML]="requestData" ></code></pre>
            </div>
        </div>

        <p>Using Akamai HLS Player, we can view the output.</p>

        <p>
            From getSession response, we got the output endpoint or
            manifest path : https://media.optimusdrive.ai/live/ef0556cf-d62d-4ee6-90fb-3437cd972e89/hls/master.m3u8
        </p><br>


        <img class="img-thumbnail" src="/assets/images/broadcaste.jpg" alt="broadcast">

    </div>
</div>